import { Spin } from "antd"
import { LoadingOutlined } from '@ant-design/icons';
const UiLoader = ({
    spinning = false,
    size = "large",
    fullscreen = true
}) => {
    return <div>
        <Spin spinning={spinning} size={size} fullscreen={fullscreen} indicator={<LoadingOutlined style={{ fontSize: 70, color: '#ad8d45',strokeWidth: 8}} spin />} >
            <div style={{ minHeight: '100px'}} />
        </Spin>
    </div>
};
export default UiLoader